<template>
  <div class="content-panel tableTree" >
    <a-card :bordered="false">
      <div class="input">
        <a-input-search placeholder="请输入权限表名称" style="width: 100%" @search="onSearch" />
      </div>
      <template v-if="$auth('datapermission.addTable')">
        <a-button type="primary" block style="margin-top:10px" @click="addNew">新建权限表</a-button>
      </template>
      <a-tree
        :tree-data="treeData"
        :show-line="true"
        :show-icon="true"
        @select="onSelect"
      >
        <template slot="custom" slot-scope="item">
          <div :ref="'tree'+item.id" class="treeTitle">
            {{ item.name }}【{{ item.comment }}】
          </div>
          <div class="icon-panel">
            <template v-if="$auth('datapermission.modifyTable')">
              <a-tooltip>
                <template slot="title">
                  编辑
                </template>
                <a-icon type="edit" @click="() => editTreeData(item)" style="margin-right:10px"/>
              </a-tooltip>
            </template>
            <template v-if="$auth('datapermission.deleteTable')">
              <a-popconfirm placement="topRight" :title="'您确定要删除【' + item.name + '】吗?'" @confirm="e => remove(item)">
                <a-tooltip>
                  <template slot="title">
                    删除
                  </template>
                  <a-icon type="delete" @click="() => deleteTreeData(item)" />
                </a-tooltip>
              </a-popconfirm>
            </template>
          </div>
        </template>
        <!--        <template slot="custom" slot-scope="item">-->
        <!--          <div class="treeNodeContainer" slot="title">-->
        <!--            <div class="title" >-->
        <!--              <a-icon type="book" style="position: relative;margin-right: 10px"/>{{item.name}}</div>-->
        <!--            <div class="actions" >-->
        <!--              <a-tooltip>-->
        <!--                <template slot="title">-->
        <!--                  编辑-->
        <!--                </template>-->
        <!--                <a-icon type="edit" @click="() => editTreeData(item)" style="margin-right:10px"/>-->
        <!--              </a-tooltip>-->
        <!--              <a-popconfirm placement="topRight" :title="'您确定要删除【' + item.name + '】吗?'" @confirm="e => remove(item)">-->
        <!--                <a-tooltip>-->
        <!--                  <template slot="title">-->
        <!--                    删除-->
        <!--                  </template>-->
        <!--                  <a-icon type="delete"  @click="() => deleteTreeData(item)" />-->
        <!--                </a-tooltip>-->
        <!--              </a-popconfirm>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </template>-->
      </a-tree>
    </a-card>
  </div>
</template>

<script>
import { getTableList, deleteTable } from '@/api/table'
export default {
  name: 'ZmTree',
  data () {
    return {
      treeData: [],
      originalData: [],
      showLine: false,
      showIcon: false,
      searchCondition: ''
    }
  },
  computed: {
  },
  watch: {
    searchCondition (newVal) {
      if (newVal) {
        this.filterData()
      }
    }
  },
  mounted () {
    this.initTreeData()
  },
  methods: {
    // 清空搜索条件
    changeTreeSearch () {

    },
    // 查询
    filterData () {
      if (this.searchCondition) {
        this.treeData = JSON.parse(JSON.stringify(this.originalData))
        this.treeData = this.treeData.filter(item => {
          if (item.name.indexOf(this.searchCondition) > -1) {
            return item
          }
          return null
        })
      } else {
        this.treeData = this.originalData
      }
    },
    // 删除
    remove (item) {
      deleteTable(item.id).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTreeData()
          this.$emit('clearForm')
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    //  新建
    addNew () {
      this.$emit('clearForm')
    },
    // 编辑
    editTreeData (item) {
      console.log('item', item)
      this.$emit('setFormType', 'edit')
      this.$emit('setFormData', item)
    },
    // 删除
    deleteTreeData (item) {
      console.log('item', item)
    },
    onSearch (keys, event) {
      this.searchCondition = keys
      this.filterData()
    },
    // 初始化treeData
    initTreeData () {
      getTableList({
        paging: false
      }).then(res => {
        if (res.status === 0) {
          this.treeData = res.data.map(item => {
            item.scopedSlots = { title: 'custom' }
            return item
          })
          if (this.treeData && this.treeData.length > 0) {
            this.$nextTick(() => {
              const refId = 'tree' + this.treeData[0].id
              this.$refs[refId].click()
            })
          }
          this.originalData = JSON.parse(JSON.stringify(this.treeData))
        } else {
          this.$message.warning('获取数据失败')
          this.treeData = []
          this.originalData = []
        }
      }).catch(error => {
        this.$message.warning('获取数据失败')
        this.treeData = []
        this.originalData = []
      })
    },
    // 新增占位符
    addData () {

    },
    // 删除占位符
    deleteData () {

    },
    // 选择树节点
    onSelect (keys, info) {
      if (info.selectedNodes[0]) {
        const item = info.selectedNodes[0].data.props.dataRef
        this.$emit('setFormData', item)
      }
      this.$emit('setFormType', 'edit')
    }

  }
}
</script>

<style  lang="less" >
  .tableTree{
    .ant-tooltip {
      z-index: 1020;
    }
    .treeTitle{
      width:190px;
      display: inline-block;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .content-panel {
      // .ant-tree-title {
      //   width: 100%;

      //   & > span {
      //     // width: 90px;
      //     display: inline-block;
      //     white-space: pre-line;
      //   }
      // }
      // .title {
      //   float: left;
      // }

      .ant-card-body {
        padding: 0;
        .ant-btn {
          margin-bottom: 12px;
        }

        // :global {
        //   .ant-tree {
        //     line-height: 3;

        //     .ant-tree-node-content-wrapper,
        //     .ant-tree-switcher {
        //       margin-top: 7px;
        //     }

        //     .ant-tree-node-content-wrapper:hover {
        //       background: transparent;
        //     }

        //     .ant-tree-treenode-selected {
        //       background: #e6f7ff;

        //       .ant-tree-node-selected {
        //         background: transparent;
        //       }
        //     }

        //     .ant-tree-child-tree {
        //       background: #fff;
        //     }

        //     li {
        //       position: relative;
        //       line-height: 3;
        //       padding-bottom: 0;
        //     }
        //   }
        //   .ant-tree.ant-tree-show-line li.ant-tree-treenode-selected span.ant-tree-switcher {
        //     background-color: #e6f7ff;
        //   }

        //   .icon-panel {
        //     float: right;
        //     position: absolute;
        //     right: 10px;
        //     top: 13px;

        //     .anticon-edit,
        //     .anticon-setting,
        //     .anticon-delete {
        //       margin-left: 5px;
        //       color: #1890ff;
        //     }
        //   }
        // }
      }
    }
  }

</style>
